import { getApi } from '@/stores/api'
import { getModuleFromPath } from '@/stores/module'
import { MILLIS } from '@repo/constants'
import { useQuery } from '@tanstack/react-query'
import { useVerifySession } from './useVerifySession'

export async function getMe(signal?: AbortSignal) {
  const api = getApi()
  // The module the user is in, so the backend can record that they were seen there. Taken from the
  // page's own path, which the route tree makes authoritative, rather than from the persisted active
  // module, which only changes when the switcher is used. The backend ignores a module the user's
  // roles do not grant, so nothing here can invent access.
  const res = await api.users.me.$post(
    { json: { module: getModuleFromPath(window.location.pathname) } },
    { init: { signal } },
  )

  const me = await res.json()
  return me
}

export type LoggedInUser = ReturnType<typeof getMe> extends Promise<infer T> ? T : never

export function useMe() {
  const { isSuccess } = useVerifySession()

  return useQuery({
    queryKey: ['me'],
    queryFn: async ({ signal }) => await getMe(signal),
    enabled: isSuccess,
    staleTime: MILLIS.MINUTE * 5,
  })
}

export type AuthUser = ReturnType<typeof getMe> extends Promise<infer T> ? T : never
